import React, { useState, useEffect } from 'react';
import { X, Shuffle } from 'lucide-react';
import api from '../../../api.js';

function OrganizationTransferModal({ isOpen, onClose, onSuccess, onMessage, vehicle, organizations }) {
  const [selectedOrgId, setSelectedOrgId] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (vehicle && isOpen) {
      setSelectedOrgId(vehicle.org_id || '');
    }
  }, [vehicle, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedOrgId) {
      onMessage && onMessage({
        title: 'Erreur',
        message: 'Veuillez sélectionner une organisation',
        type: 'error'
      });
      return;
    }

    setLoading(true);
    try {
      await api.vehicle.update(vehicle.id, { org_id: selectedOrgId });
      onMessage && onMessage({
        title: 'Succès',
        message: 'Véhicule transféré avec succès',
        type: 'success'
      });
      onSuccess && onSuccess();
      onClose();
    } catch (error) {
      console.error('Error transferring vehicle:', error);
      onMessage && onMessage({
        title: 'Erreur',
        message: 'Impossible de transférer le véhicule',
        type: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  const currentOrg = organizations.find(o => o.code === vehicle?.org_id);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="bg-purple-500 text-white px-6 py-4 rounded-t-lg">
          <div className="flex justify-between items-center">
            <h3 className="text-xl font-bold">Transférer à une Organisation</h3>
            <button onClick={onClose} className="text-white hover:text-gray-200">
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div>
            <div className="bg-gray-50 p-4 rounded-lg mb-4">
              <p className="text-sm text-gray-600 mb-1">Véhicule</p>
              <p className="font-semibold text-gray-900">{vehicle?.make} {vehicle?.model}</p>
              <p className="text-sm text-gray-600">{vehicle?.license_plate}</p>
            </div>

            <div className="bg-blue-50 p-4 rounded-lg mb-4">
              <p className="text-sm text-gray-600 mb-1">Organisation Actuelle</p>
              <p className="font-semibold text-gray-900">{currentOrg?.name || 'Non affectée'}</p>
              {currentOrg && (
                <p className="text-xs text-gray-600">Code: {currentOrg.code}</p>
              )}
            </div>

            <label className="block text-sm font-medium text-gray-700 mb-2">
              Nouvelle Organisation *
            </label>
            <select
              value={selectedOrgId}
              onChange={(e) => setSelectedOrgId(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500"
              required
            >
              <option value="">-- Sélectionner une organisation --</option>
              {organizations.map(org => (
                <option key={org.id} value={org.code}>
                  {org.name} ({org.code})
                </option>
              ))}
            </select>
          </div>

          <div className="flex justify-end gap-3 pt-4 border-t">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
              disabled={loading}
            >
              Annuler
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 flex items-center gap-2 disabled:opacity-50"
              disabled={loading}
            >
              {loading ? 'Transfert...' : 'Transférer'}
              <Shuffle className="w-4 h-4" />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default OrganizationTransferModal;
